import { Box } from '@mui/material';
import config from '../config';

export function EnvironmentIdentifier(props) {
  const { children, showBorder = true, ...rest } = props;

  const identifier = config.isProd ? null : (
    <Box
      component="fieldset"
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        border: showBorder ? '4px solid #629749' : 'none',
        color: '#629749',
        zIndex: 999999,
        pointerEvents: 'none',
        margin: 0,
        padding: 0,
        '& legend': {
          float: 'none',
          margin: '0 auto',
          fontFamily: 'monospace',
          fontSize: 10,
          lineHeight: 0,
          padding: '4px 0 0',
          px: 0.5,
        },
      }}
    >
      <legend>{config.environment}</legend>
    </Box>
  );

  return (
    <Box {...rest}>
      {identifier}
      {children}
    </Box>
  );
}
